module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "paper-question"
  }, [_c('div', {
    staticClass: "p-30 bg-fff m-t30"
  }, [(_vm.question.qtype == 1) ? _c('singleChoice', {
    attrs: {
      "playerObj": _vm.playerObj,
      "moduleId": _vm.moduleId,
      "question": _vm.question
    },
    on: {
      "playedObj": _vm.playedObj
    }
  }) : (_vm.question.qtype == 2) ? _c('multipleChoice', {
    attrs: {
      "playerObj": _vm.playerObj,
      "moduleId": _vm.moduleId,
      "question": _vm.question
    },
    on: {
      "playedObj": _vm.playedObj
    }
  }) : (_vm.question.qtype == 3) ? _c('filling', {
    attrs: {
      "playerObj": _vm.playerObj,
      "moduleId": _vm.moduleId,
      "question": _vm.question
    },
    on: {
      "playedObj": _vm.playedObj
    }
  }) : (_vm.question.qtype == 4) ? _c('allFilling', {
    attrs: {
      "playerObj": _vm.playerObj,
      "moduleId": _vm.moduleId,
      "question": _vm.question
    },
    on: {
      "playedObj": _vm.playedObj
    }
  }) : (_vm.question.qtype == 5) ? _c('reading', {
    attrs: {
      "playerObj": _vm.playerObj,
      "moduleId": _vm.moduleId,
      "question": _vm.question
    },
    on: {
      "playedObj": _vm.playedObj
    }
  }) : (_vm.question.qtype == 6) ? _c('shortanswer', {
    attrs: {
      "playerObj": _vm.playerObj,
      "moduleId": _vm.moduleId,
      "question": _vm.question
    },
    on: {
      "playedObj": _vm.playedObj
    }
  }) : (_vm.question.qtype == 7) ? _c('imitation', {
    attrs: {
      "playerObj": _vm.playerObj,
      "moduleId": _vm.moduleId,
      "question": _vm.question
    },
    on: {
      "playedObj": _vm.playedObj
    }
  }) : (_vm.question.qtype == 8) ? _c('judge', {
    attrs: {
      "playerObj": _vm.playerObj,
      "moduleId": _vm.moduleId,
      "question": _vm.question
    },
    on: {
      "playedObj": _vm.playedObj
    }
  }) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6c061588","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/watchSinglePaper.vue
// module id = 1215
// module chunks = 1